<template>
    <transition name="fade" mode="out-in">
        <div v-if="isOpen" class="popup" cy-data="popup">
            <button
                class="popup__button"
                type="button"
                cy-data="popup-button"
                @click="buttonClicked"
            />
            <div class="popup__content-view fs-12">
                <slot />
            </div>
        </div>
    </transition>
</template>

<script lang="ts">
import { defineComponent, toRefs } from 'vue';

export default defineComponent({
    name: 'Popup',
    props: {
        isOpen: Boolean,
    },
    emits: ['buttonClicked'],
    setup(props, { emit }) {
        const { isOpen } = toRefs(props);

        const buttonClicked = () => {
            emit('buttonClicked');
        };

        return {
            isOpen,
            buttonClicked,
        };
    },
});
</script>
